const vq7mkm8 = require('./public/authorPage-members.js');
const vha2kec = require('./public/authorPage.js');
const vohljdf = require('./public/postPage.js');
const v45h8wh = require('./public/seo-utils.js');
const vtjiisr = require('./public/settings.js');
const vdr2nh = require('./public/test.js');
const vsqjn = require('./public/utils.js');

module.exports = {
	...vq7mkm8,
	...vha2kec,
	...vohljdf,
	...v45h8wh,
	...vtjiisr,
	...vdr2nh,
	...vsqjn
};
